import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactSelect, { MenuPlacement, SingleValue } from 'react-select';

import { LanguageOption, LanguageService } from '@umanforge/common';

interface LanguageSelectorProps {
  menuPlacement: MenuPlacement;
  value?: LanguageOption;
  disabled?: boolean;
  onChange?: ( newValue: LanguageOption ) => void;
};

export const LanguageSelector = ( { menuPlacement, value, onChange, disabled = false }: LanguageSelectorProps ) => {
  const { t, i18n } = useTranslation();

  const languages: readonly LanguageOption[] = LanguageService.getLanguages();
  const [ selectedLanguage, setSelectedLanguage ] = useState( value ?? languages.find( lang => { return lang.value === i18n.language; } ) );

  useEffect( () => {
    document.title = t( 'Authentication' );
  }, [ i18n.language ] );

  const onChangeLang = ( newValue: SingleValue<LanguageOption> ) => {
    setSelectedLanguage( newValue ?? languages.find( lang => { return lang.value === i18n.language; } ) );
    if ( onChange != null ) {
      onChange( newValue as LanguageOption );
    }
  };


  return (
    <div className="flex m-2">
      <ReactSelect
        required
        value={ selectedLanguage }
        options={ languages }
        isDisabled={ disabled }
        onChange={ onChangeLang }
        menuPlacement={ menuPlacement }
        formatOptionLabel={ language => {
          return (
            <div className="flex gap-2">
              <div className="w-6 rounded-md">
                { language.flag }
              </div>
              <span className='text-sm font-medium'>{ language.label }</span>
            </div>
          ); }
        }
      />
    </div>
  );
};